import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import '../styles/components/image-uploader.css';
import image from '../assets/images/image-upload.png';
import imageCompression from 'browser-image-compression';

const ImageUploader = ({ 
  onFilesChange, 
  maxSize = 10 * 1024 * 1024,
  maxFiles = 1,
  accept = 'image/*',
  placeholder = "사진을 업로드해주세요",
  showPreview = true,
  ...props 
}) => {
  const [files, setFiles] = useState([]);

  async function compressImage(file) {
    const options = {
      maxSizeMB: 0.5, // 최대 0.5MB 이하로
      maxWidthOrHeight: 1280, // 해상도 제한
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      return compressedFile;
    } catch (e) {
      console.error('이미지 압축 오류:', e);
      return file;
    }
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    maxSize,
    maxFiles,
    multiple: true,
    onDrop: async (acceptedFiles, fileRejections) => {
      if (fileRejections.length > 0) {
        const oversizeFiles = fileRejections.filter(rej =>
            rej.errors.some(err => err.code === 'file-too-large')
        );
        if (oversizeFiles.length > 0) {
          alert('이미지 용량이 너무 큽니다. 최대 10MB 이하로 업로드해주세요.');
        }
      }

      // 압축 및 확장자 변경
      const processedFiles = await Promise.all(
          acceptedFiles.map(async (file) => {
            let processed = file;

            // HEIC 확장자 가짜로 jpg 처리
            if (file.name.toLowerCase().endsWith('.heic')) {
              processed = new File([file], file.name.replace(/\.heic$/i, '.jpg'), {
                type: 'image/jpeg',
                lastModified: file.lastModified,
              });
            }

            // 이미지 압축 적용
            const compressed = await compressImage(processed);
            return compressed;
          })
      );

      const newFiles = [...files, ...processedFiles];
      const limitedFiles = maxFiles ? newFiles.slice(0, maxFiles) : newFiles;

      setFiles(limitedFiles);
      if (onFilesChange) {
        onFilesChange(limitedFiles);
      }
    },
    ...props
  });

  const removeFile = (index) => {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
    
    if (onFilesChange) {
      onFilesChange(newFiles);
    }
  };

  return (
    <div className="image-uploader">
      <div 
        {...getRootProps()} 
        className={`dropzone ${isDragActive ? 'dropzone-active' : ''}`}
      >
        <input {...getInputProps()} />
            <img src={image} alt="image upload" className="tag-image" />
            <p>{placeholder}</p>
            <p className="limit-text">최대 {maxFiles}장</p>
      </div>

      {showPreview && files.length > 0 && (
        <div className="preview-container">
          <p className="preview-title">업로드된 파일 ({files.length}개):</p>
          <div className="preview-grid">
            {files.map((file, index) => (
              <div key={index} className="preview-item">
                <img
                  src={URL.createObjectURL(file)}
                  alt={file.name}
                  className="preview-image"
                />
                <button
                  onClick={() => removeFile(index)}
                  className="remove-button"
                >
                  ×
                </button>
                <p className="file-name">
                  {file.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUploader;